// 이 앱의 캐시 초기화(index.tsx)가 지우면 안 되는 localStorage 키.
// 캐시 초기화는 새 배포·1시간 미사용 때 같은 주소(awanaevent.com)의 localStorage 를 통째로 지운다.
//
// 영성수련회 안내 페이지(/retreat/info/, services/retreat-info)도 같은 주소다. 지워지면 참가자가 영수증 화면을
// 한 번 열었다 돌아갔을 뿐인데 등록 정보·오프라인 스탬프·행운권 기기 번호(당첨 수령에 필요)가 사라진다.
//   awana-retreat-2026-v2  등록 정보·스탬프·전송 대기열
//   rt-device · rt-alerts · rt-sound  행운권 기기 번호, 본 알림, 소리 설정
//   retreat2026-popup-hide  업체 팝업 "오늘 하루 보지 않기"
// 첫 화면 팝업(components/eventPopupHide.ts)의 "오늘 하루 보지 않기"도 남긴다 — 지워지면 같은 날 다시 뜬다.
//   awana-popup-hide-<팝업 ID>
const PRESERVED_KEY = /^(awana-retreat-|rt-|retreat2026-|awana-popup-hide-)/;

export const isPreservedStorageKey = (key: string): boolean => PRESERVED_KEY.test(key);

// index.tsx 의 캐시 초기화가 지울 키 — keep 에 든 키와 위 키는 뺀다.
export const localStorageKeysToClear = (keys: string[], keep: string[]): string[] =>
  keys.filter((key) => !keep.includes(key) && !isPreservedStorageKey(key));
